module.exports = __webpack_public_path__ + "img/she-profile.39cdcc75.svg";